import { useState, useEffect, useCallback } from 'react';
import { fetchTeorico, fetchConsumoReal, fetchCostosTeoricos } from '../services/detergentesQuimicos.services';

// Hook: Detergentes y Químicos — consumo teórico + real + costos teóricos.
// Las 3 llamadas son independientes entre sí; se disparan en paralelo.
export const useDetergentesQuimicos = ({ idLavanderia, dateRange, enabled = true }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!enabled || !idLavanderia || !dateRange) return;
    setLoading(true);
    setError(null);
    try {
      const [teorico, real, costosTeoricos] = await Promise.all([
        fetchTeorico({ idLavanderia, dateRange }),
        fetchConsumoReal({ idLavanderia, dateRange }),
        fetchCostosTeoricos({ idLavanderia }),
      ]);
      setData({ teorico, real, costosTeoricos });
    } catch (e) {
      setError(e.message || 'Error al cargar el consumo de detergentes y químicos');
    } finally {
      setLoading(false);
    }
  }, [idLavanderia, dateRange, enabled]);

  useEffect(() => {
    load();
  }, [load]);

  return { data, loading, error, reload: load };
};
